// src/services/api.js
// Cliente HTTP de la API (Express + PostgreSQL). Reemplaza Firebase.
// REACT_APP_API_URL vacío => '/api' (Netlify lo reenvía al backend).
const BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/+$/, '');

// "Sucursal actual" del panel (administrador). Viaja en cada petición para que la API limite
// los datos a esa sucursal; vacío o 'all' = vista global. Lo fija SucursalActivaProvider.
let sucursalContexto = '';
const clavesPendientes = new Map();
const RUTA_FINANCIERA = /^\/(?:finanzas\/(?:depositos|cuentas-por-pagar\/[^/]+\/pagar)|pagos-administrativos|liquidaciones\/(?:cierre\/[^/]+|instrucciones\/[^/]+\/(?:realizar|cambiar-destino))|bancos\/movimientos|data\/(?:pagos|aperturas\/[^/]+\/(?:compras|gastos)))$/;
function claveIdempotencia(method, path, body) {
  if (method !== 'POST' || !RUTA_FINANCIERA.test(path)) return null;
  const dato = `${path}|${JSON.stringify(body || {})}`;
  let hash = 2166136261;
  for (let i = 0; i < dato.length; i++) hash = Math.imul(hash ^ dato.charCodeAt(i), 16777619);
  const nombre = `operacion:${path}:${(hash >>> 0).toString(16)}:${dato.length}`;
  let clave = clavesPendientes.get(nombre);
  try { clave ||= sessionStorage.getItem(nombre); } catch {}
  if (!clave) {
    clave = crypto.randomUUID();
    clavesPendientes.set(nombre, clave);
    try { sessionStorage.setItem(nombre, clave); } catch {}
  }
  return { nombre, clave };
}
function olvidarClave(op) {
  if (!op) return;
  clavesPendientes.delete(op.nombre);
  try { sessionStorage.removeItem(op.nombre); } catch {}
}
export function setSucursalContexto(id) { sucursalContexto = id && id !== 'all' ? String(id) : ''; }

export function getToken() {
  try { return localStorage.getItem('token') || ''; } catch { return ''; }
}

export const MUST_CHANGE_KEY = 'must_change_password';
// Aviso que muestra el login al llegar por una sesión vencida o rechazada.
export const AVISO_LOGIN_KEY = 'aviso_login';
export const SESION_VENCIDA = 'Tu sesión ha vencido. Inicia sesión nuevamente.';
export function avisarSesionVencida() { try { sessionStorage.setItem(AVISO_LOGIN_KEY, SESION_VENCIDA); } catch {} }
export const RUTA_CAMBIO_CONTRASENA = '/cambiar-contrasena';

export function clearSession() {
  sucursalContexto = '';
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('username');
    localStorage.removeItem(MUST_CHANGE_KEY);
  } catch {}
  // remember_username se conserva a propósito (preferencia del usuario)
}

export class ApiError extends Error {
  constructor(message, status, body) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

/**
 * Llama a la API. Devuelve `data` del sobre { ok, data }.
 * Un 401 con sesión activa cierra la sesión y manda al login.
 */
export async function api(method, path, body, { auth = true } = {}) {
  const headers = {};
  const op = claveIdempotencia(method, path, body);
  if (op) headers['Idempotency-Key'] = op.clave;
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  const token = auth ? getToken() : '';
  if (token) headers.Authorization = `Bearer ${token}`;
  if (token && sucursalContexto) headers['X-Sucursal-Activa'] = sucursalContexto;

  const resp = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  olvidarClave(op);

  let json = null;
  try { json = await resp.json(); } catch {}

  if (resp.status === 401 && token) {
    clearSession();
    avisarSesionVencida();
    if (!window.location.pathname.startsWith('/login')) window.location.assign('/login');
  }
  // DebeCambiarContrasena: la API solo permite cambiar la contraseña.
  if (resp.status === 403 && json?.code === 'MUST_CHANGE_PASSWORD') {
    try { localStorage.setItem(MUST_CHANGE_KEY, '1'); } catch {}
    if (window.location.pathname !== RUTA_CAMBIO_CONTRASENA) window.location.assign(RUTA_CAMBIO_CONTRASENA);
  }
  if (!resp.ok) {
    throw new ApiError(json?.message || `HTTP ${resp.status}`, resp.status, json);
  }
  return json && 'data' in json ? json.data : json;
}

export const apiGet = (path) => api('GET', path);
export const apiPost = (path, body) => api('POST', path, body);
export const apiPut = (path, body) => api('PUT', path, body);
export const apiPatch = (path, body) => api('PATCH', path, body);
export const apiDelete = (path, body) => api('DELETE', path, body);
